<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Fecha Entrega*</mat-label>
                <input matInput
                    formControlName="a4FechaEntrega"
                    [matDatepicker]="fechaEntregaPicker"
                   (dateChange)="dateChange($event)"
                >
                <mat-datepicker-toggle matSuffix [for]="fechaEntregaPicker"></mat-datepicker-toggle>
                <mat-datepicker #fechaEntregaPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Dependencia Entrega*</mat-label>
                <input matInput formControlName="a4Dependencia" [matAutocomplete]="a4Dependencia">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #a4Dependencia="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of dependenciaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Periodicidad*</mat-label>
                <input matInput formControlName="a4Periodicidad" [matAutocomplete]="a4Periodicidad">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #a4Periodicidad="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of periodicidadFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Periodo Pertenece*</mat-label>
                <input matInput formControlName="a4Periodo">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Nombre Responsable*</mat-label>
                <input matInput formControlName="a4ResponsableEntregaNombre">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Primer Apellido Responsable*</mat-label>
                <input matInput formControlName="a4ResponsableEntregaPrimerApe">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Segundo Apellido Responsable</mat-label>
                <input matInput formControlName="a4ResponsableEntregaSegundoApe">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Puesto Responsable*</mat-label>
                <input matInput formControlName="a4Puesto">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Teléfono Responsable*</mat-label>
                <input matInput formControlName="a4TelefonoResponsable">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Observaciones*</mat-label>
                <input matInput formControlName="a4Observaciones">
            </mat-form-field>
        </div>
    </div>
</form>
